import { render, staticRenderFns } from "./input.vue?vue&type=template&id=52275a91&scoped=true"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"
import style0 from "./input.vue?vue&type=style&index=0&id=52275a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52275a91",
  null
  
)

export default component.exports